import { useTranslation } from 'react-i18next';
import { Dialog, IconCreditCard } from '@coverflex-tech/hypernova';

interface IErrorModalProps {
  onClose: () => void;
  error: IModalError;
}
export interface IModalError {
  title: string;
  description: string;
}

export const ErrorModal = ({ onClose, error }: IErrorModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      icon={<IconCreditCard />}
      title={error?.title}
      message={error?.description}
      onClose={onClose}
      primaryAction={{
        children: t('activate_card.error.button'),
        onClick: (closeDialog) => closeDialog(),
      }}
    />
  );
};
